export default __webpack_public_path__ + "static/media/ilus-badge-qualified.a6381712.svg";